export default {
  FIXTURES: 'filter_fixtures',
  TABLES: 'filter_tables',
};
